'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pick(keys, subject) {
  var keySet = _immutable.Seq.Set(keys);
  return (0, _filter3.default)(function (value, key) {
    return keySet.contains(key);
  }, subject);
}

/**
 * Select specified keys from a KeyedIterable (e.g. a `Map` or `OrderedMap`).
 *
 * @example
 * // returns Map { "one" => 1, "three" => 3 }
 * pick(
 *   ['one', 'three'],
 *   Map({one: 1, two: 2, three: 3})
 * );
 *
 * @param  {Array|Iterable|Object} keys to select.
 * @param  {KeyedIterable} subject from which to select `keys`.
 * @return {KeyedIterable} with just `keys`.
 */
exports.default = (0, _curry2.default)(pick);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/pick.js
// module id = 400
// module chunks = 2 3